import { CaptionTypography, H4Typography } from '@components/atoms';
import { Card, CardContent, CardHeader } from '@components/molecules';
import * as React from 'react';

export interface CardSecondaryLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string;
	description: string;
	'aria-label'?: string;
}

export const CardSecondaryLayout: React.FC<CardSecondaryLayoutProps> = ({
	title,
	description,
	children,
	'aria-label': ariaLabel = 'card',
}) => {
	return (
		<Card data-testid="card-secondary-layout" id={ariaLabel} aria-label={ariaLabel}>
			<CardHeader className="flex flex-col items-center text-center border-none gap-2">
				<H4Typography className="text-primary">{title}</H4Typography>
				<CaptionTypography className="grow overflow-hidden text-secondary whitespace-pre-line">
					{description}
				</CaptionTypography>
			</CardHeader>
			<CardContent>{children}</CardContent>
		</Card>
	);
};
